import axios from 'axios';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// There should only be one filters form per page
const form = document.getElementById('filters-form');
const filters = document.querySelectorAll('.js-filter');
const ajaxContainer = document.getElementById('ajax-cards');
const filteredGrid = document.getElementById('filtered-grid');
const searchInput = document.getElementById('db-search-input');

function ajax(options) {
  const { url, paginate = false, updateHistory = true } = options;
  const body = document.body;
  // Add css class - temporarily disable further clicks on filters and cards
  body.classList.add('loading-ajax-cards');

  axios.get(url).then((res) => {
    if (history && updateHistory) {
      history.pushState('', '', url);
    }
    const parser = new DOMParser();
    const resHTML = parser.parseFromString(res.data, "text/html");
    const newContainer = resHTML.getElementById('ajax-cards');
    const newContent = newContainer.innerHTML;
    // Prevent height 'jump' when swapping content
    const height = ajaxContainer.offsetHeight;
    ajaxContainer.style.height = `${height}px`;
    ajaxContainer.innerHTML = newContent;
    ajaxContainer.style.height = `auto`;

    gsap.from('.js-ajax-card', {
      opacity: 0,
      y: 10,
      duration: 0.4,
      stagger: 0.1,
    });

    if (paginate) {
      gsap.to(window, {
        scrollTo: {
          y: filteredGrid,
          // offsetY: () => {
          //   const header = document.getElementById('header');
          //   const headerHeight = header.offsetHeight;
          //   return headerHeight;
          // }
        },
        duration: 0.2,
      })
    }
  }).catch((err) => {
    console.log(err);
  }).finally(() => {
    body.classList.remove('loading-ajax-cards');
  });
}

function handle(e) {
  if (e.type === 'submit') {
    e.preventDefault();
  }
  const checked = Array.from(form.querySelectorAll('.js-filter:checked'));
  
  const href = window.location.href;
  // Always remove page number when updating filters
  const baseUrl = href.includes('/page') ? href.split('/page')[0] : href.split('?')[0];
  const newUrl = new URL(baseUrl);
  if (checked.length) {
    const sectorCheckBoxes = Array.from(form.querySelectorAll('[name="sector[]"]:checked'));
    const regionCheckBoxes = Array.from(form.querySelectorAll('[name="region[]"]:checked'));
    const affectedCheckBoxes = Array.from(form.querySelectorAll('[name="affected[]"]:checked'));
    let params = newUrl.searchParams;
    
    const sectorCheckBoxValues = sectorCheckBoxes.map(sectorCheckBox => sectorCheckBox.value);
    const regionCheckBoxValues = regionCheckBoxes.map(regionCheckBox => regionCheckBox.value);
    const affectedCheckBoxValues = affectedCheckBoxes.map(affectedCheckBox => affectedCheckBox.value);

    if (sectorCheckBoxes.length) params.set("sector", sectorCheckBoxValues);
    if (regionCheckBoxes.length) params.set("region", regionCheckBoxValues);
    if (affectedCheckBoxes.length) params.set("affected", affectedCheckBoxValues);
  }
  // Check if search input is empty
  if (searchInput) {
    if (searchInput.value === '') {
      newUrl.searchParams.delete("search");
    } else {
      newUrl.searchParams.set("search", searchInput.value);
    }
  }
  ajax({url: newUrl});
}

function resetFilters() {
  form.reset();
  // form.reset() doesn't seem to empty search input if it already contains a value on page load
  // So we have to manually empty it just to be on the safe side
  if (searchInput) searchInput.value = '';
  const href = window.location.href;
  // Always remove page number when updating filters
  let url = href.includes('/page') ? href.split('/page')[0] : href.split('?')[0];
  ajax({url: url});
}

function paginate(link) {
  const url = decodeURIComponent(link.href);
  ajax({url: url, paginate: true});
}

export default function() {
  if (!form) return;
  document.addEventListener('click', function(e) {
    // Allow command-click and control-click to open new tab
    // http://henleyedition.com/allow-ctrl-command-click-using-event-preventdefault/
    if (e.metaKey || e.ctrlKey) {
      return;
    }
    const clicked = e.target;
    const paginateLink = clicked.closest('.js-filter-paginate-link');
    const resetButton = clicked.closest('#filters-form-reset');
    if (paginateLink) {
      e.preventDefault();
      paginate(paginateLink);
    } else if (resetButton) {
      resetFilters();
    }
  });

  // Not as slick but we've previously tried restoring a filtered page via ajax and it was a bit of a nightmare..
  window.addEventListener('popstate', (e) => {
    window.location.reload();
  });

  form.addEventListener('submit', handle);
  filters.forEach(filter => filter.addEventListener('change', handle));
}
